import { IOfferedSubject, IOfferedSubjectSection } from "../types";
import { IInscribedSubject } from "../types/inscribedSubjects";

/**
 * Obtiene el título de la materia de la oferta
 * @param idMateria - El id de la materia
 * @param idCurso - El id del curso
 * @param oferta - La oferta de las materias
 * @returns El título del curso de la oferta
 */
export const getOfferSubjectTitle = (idMateria: number, idCurso: number, oferta: IOfferedSubject[] | null) => {
  return (
    oferta
      ?.find((sub: IOfferedSubject) => Number(sub.id) === idMateria)
      ?.sections.find((section: IOfferedSubjectSection) => Number(section.idCurso) === idCurso)?.title || "---"
  );
};

/**
 * Obtiene el título de la materia inscrita
 * @param idMateria - El id de la materia
 * @param materiasInscriptas - Las materias inscritas
 * @returns El título de la materia inscrita
 */
export const getInscribedSubjectTitle = (idMateria: number, materiasInscriptas: IInscribedSubject[] | null) => {
  return materiasInscriptas?.find((sub: IInscribedSubject) => Number(sub.id) === idMateria)?.title || "---";
};
